/* eslint-disable */
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import {
  Autocomplete,
  InputAdornment,
  TextField,
  Typography,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import api, { authHeader } from '../../../../../../services/API/apiConfig';
import { currencyMask } from '../../../../../styles/util';
import {
  BackBtnStyled,
  BtnFilterStyled,
  ClearBtnStyled,
  ContainerButtonsStyled,
  ContainerInputsStyled,
  ContainerStyled,
  CustomInputDateStyled,
  CustomInputStyled,
  FilterHeadStyled,
  FormStyled,
  LabelStyled,
  MobileFilterStyled,
  TextFieldAutoCompleteStyled,
  TextFieldsStyled,
} from './MobileFilter.styles';

const MobileFilter = ({
  openFilter,
  setOpenFilter,
  suppliers,
  id,
  getPayables,
  filter,
  setFilter,
}) => {
  const [due, setDue] = useState(null);
  const [creationDate, setCreationDate] = useState(null);
  const [interval1, setInterval1] = useState(null);
  const [interval2, setInterval2] = useState(null);
  const [periodError, setPeriodError] = useState(false);
  const [lastPayablesNumber, setLastPayablesNumber] = useState(null);
  const [valueDisplay, setValueDisplay] = useState(null);
  const [total, setTotal] = useState(null);
  const [statusId, setStatusId] = useState('3');
  const [supplierId, setSupplierId] = useState(null);
  const [supplierName, setSupplierName] = useState('');
  const [categories, setCategories] = useState([]);
  const [categoryId, setCategoryId] = useState(null);
  const [categoryName, setCategoryName] = useState('');

  const lastPayables = [
    { value: '15', title: '15 lançamentos' },
    { value: '30', title: '30 lançamentos' },
    { value: '50', title: '50 lançamentos' },
    { value: '100', title: '100 lançamentos' },
  ];

  const status = [
    { id: '1', status: 'Pago' },
    { id: '0', status: 'Pendente' },
    { id: '3', status: 'Todos' },
  ];

  function changeValueTotal(event) {
    event.preventDefault();
    let { value } = event.target;
    setValueDisplay(value);
    value = value.replace('.', '').replace(',', '.');
    value = String(value);
    setTotal(value);
  }

  function onChangeSupplier(event, value) {
    event.preventDefault();
    if (value !== null) {
      setSupplierId(value.id);
    } else {
      setSupplierId(null);
    }
  }

  function onChangeCategory(event, value) {
    event.preventDefault();
    if (value !== null) {
      setCategoryId(value.id);
    } else {
      setCategoryId(null);
    }
    return;
  }

  async function onSubmitFilter() {
    let dateRange = null;

    if ((interval1 && !interval2) || (interval2 && !interval1)) {
      setPeriodError(true);
      return;
    }
    if (interval1 && interval2) {
      dateRange = `${interval1}, ${interval2}`;
    }

    const objFilter = {
      filter: {
        due_date: due,
        creation_date: creationDate,
        date_range: dateRange,
        last_payables: lastPayablesNumber,
        total,
        status: statusId !== '3' ? statusId : null,
        supplier: supplierId,
        category: categoryId,
      },
    };
    await api
      .post(`constructions/${id}/filters`, objFilter, {
        headers: authHeader(),
      })
      .then((res) => {
        const { status } = res.data;

        if (status === 0) {
          setFilter(res.data.data);
          getPayables();
          setOpenFilter(false);
        }
      })
      .catch((err) => console.log(err));
  }

  async function handleDeleteFilter() {
    api
      .delete(`/filters/${filter.id}`, {
        headers: authHeader(),
      })
      .then((res) => {
        if (res.data.status === 0) {
          getPayables();
          setDue('');
          setDue(null);
          setCreationDate('');
          setCreationDate(null);
          setInterval1('');
          setInterval2('');
          setInterval1(null);
          setInterval2(null);
          setLastPayablesNumber('');
          setLastPayablesNumber(null);
          setTotal('');
          setValueDisplay('');
          setTotal(null);
          setStatusId(null);
          setSupplierId(null);
          setFilter(null);
          setCategoryId(null);
        }
      })
      .catch((err) => console.log(err));
  }

  useEffect(() => {
    api
      .get('/categories', {
        headers: authHeader(),
      })
      .then((res) => {
        const { data } = res.data;
        setCategories(data);
      });

    api
      .get(`/constructions/${id}/filters`, {
        headers: authHeader(),
      })
      .then((res) => {
        const { data } = res.data;
        setFilter(data);
        setDue(data.due_date);
        setCreationDate(data.creation_date);
        setLastPayablesNumber(data.last_payables);
        setTotal(data.total);
        setValueDisplay(data.total?.replace('.', ','));
        setSupplierId(data.supplier);
        setCategoryId(data.category);
        if (data.status === null || data.status === undefined) {
          setStatusId('3');
        } else {
          setStatusId(data.status);
        }

        if (data.date_range !== undefined) {
          if (data.date_range !== null) {
            let interval = Array.from(data.date_range.split(','));
            setInterval1(interval[0]);
            setInterval2(interval[1].trim());
          }
        }
      });
  }, []);

  return (
    <ContainerStyled openFilter={openFilter}>
      <MobileFilterStyled>
        <FilterHeadStyled>
          <BackBtnStyled onClick={() => setOpenFilter(false)} type="button">
            <ArrowBackIosNewIcon style={{ fontSize: 'large' }} />
          </BackBtnStyled>
          <Typography variant="h2" style={{ fontSize: '16px' }}>
            Filtros
          </Typography>
          <ClearBtnStyled type="button" onClick={handleDeleteFilter}>
            Limpar
          </ClearBtnStyled>
        </FilterHeadStyled>

        <FormStyled>
          <ContainerInputsStyled>
            <div>
              <LabelStyled htmlFor="due">Vencimento</LabelStyled>
              <TextFieldsStyled
                id="due"
                fullWidth
                type="date"
                variant="outlined"
                value={due}
                onChange={(e) => setDue(e.target.value)}
                inputProps={{ maxLength: 10, max: '9999-12-31' }}
                size="small"
              />
            </div>
            <div>
              <LabelStyled htmlFor="release">Data de lançamento</LabelStyled>
              <TextFieldsStyled
                fullWidth
                id="release"
                type="date"
                variant="outlined"
                value={creationDate}
                onChange={(e) => setCreationDate(e.target.value)}
                inputProps={{ maxLength: 10, max: '9999-12-31' }}
                size="small"
              />
            </div>
          </ContainerInputsStyled>
          <ContainerInputsStyled>
            {' '}
            <div>
              <LabelStyled>Período de vencimento</LabelStyled>
              <CustomInputDateStyled>
                <CustomInputStyled
                  type="date"
                  value={interval1}
                  onChange={(e) => {
                    setPeriodError(false);
                    setInterval1(e.target.value);
                  }}
                  max="9999-12-31"
                />
                &minus;
                <CustomInputStyled
                  type="date"
                  value={interval2}
                  onChange={(e) => {
                    setPeriodError(false);
                    setInterval2(e.target.value);
                  }}
                  max="9999-12-31"
                />
              </CustomInputDateStyled>
            </div>
          </ContainerInputsStyled>
          <ContainerInputsStyled>
            <div style={{ width: '100%' }}>
              <LabelStyled htmlFor="lastPayables">
                Últimos lançamentos
              </LabelStyled>
              <Autocomplete
                id="lastPayables"
                fullWidth
                options={lastPayables}
                getOptionLabel={(option) => option.title}
                renderInput={(params) => (
                  <TextFieldsStyled {...params} variant="outlined" />
                )}
                value={
                  lastPayables.find(
                    (payable) => payable.value === lastPayablesNumber
                  ) || null
                }
                onChange={(e, newValue) =>
                  setLastPayablesNumber(newValue?.value || '')
                }
              />
            </div>
          </ContainerInputsStyled>
          <ContainerInputsStyled>
            <div style={{ width: '100%' }}>
              <LabelStyled htmlFor="value">Valor</LabelStyled>
              <TextFieldsStyled
                id="value"
                fullWidth
                variant="outlined"
                value={valueDisplay}
                onChange={(e) => changeValueTotal(currencyMask(e))}
                InputProps={{
                  startAdornment: <InputAdornment>R$</InputAdornment>,
                }}
                size="small"
              />
            </div>
          </ContainerInputsStyled>
          <ContainerInputsStyled>
            <div style={{ width: '100%' }}>
              <LabelStyled htmlFor="status">Status de pagamento</LabelStyled>
              <Autocomplete
                id="status"
                fullWidth
                options={status}
                getOptionLabel={(option) => option.status}
                value={status.find((st) => st.id === statusId) || null}
                onChange={(e, newValue) => setStatusId(newValue?.id || '')}
                renderInput={(params) => (
                  <TextFieldsStyled
                    {...params}
                    variant="outlined"
                    slotProps={{
                      inputLabel: { shrink: true },
                    }}
                  />
                )}
              />
            </div>
          </ContainerInputsStyled>
          <ContainerInputsStyled>
            <div style={{ width: '100%' }}>
              <LabelStyled htmlFor="supplier">Fornecedor</LabelStyled>
              <TextFieldAutoCompleteStyled
                id="supplier"
                fullWidth
                size="small"
                options={suppliers}
                value={supplierId}
                onChange={(event, newValue) =>
                  onChangeSupplier(event, newValue)
                }
                inputValue={supplierName}
                onInputChange={(event, newInputValue) =>
                  setSupplierName(newInputValue)
                }
                getOptionLabel={(options) => options.name || supplierName}
                isOptionEqualToValue={(option, value) =>
                  option.id === value?.id
                }
                noOptionsText="Nenhum fornecedor encontrado"
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    slotProps={{
                      inputLabel: { shrink: true },
                    }}
                    value={supplierName}
                    size="small"
                  />
                )}
              />
            </div>
          </ContainerInputsStyled>
          <ContainerInputsStyled>
            <div style={{ width: '100%' }}>
              <LabelStyled htmlFor="category">Categoria</LabelStyled>
              <TextFieldAutoCompleteStyled
                id="category"
                fullWidth
                options={categories}
                value={categoryId}
                onChange={(event, newValue) =>
                  onChangeCategory(event, newValue)
                }
                inputValue={categoryName}
                onInputChange={(event, newInputValue) =>
                  setCategoryName(newInputValue)
                }
                getOptionLabel={(options) => options.name || categoryName}
                isOptionEqualToValue={(option, value) =>
                  option.id === value?.id
                }
                noOptionsText="Nenhuma categoria encontrada"
                // sx={{ '.MuiInputBase-input': { height: 23 } }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    value={categoryName}
                  />
                )}
              />
            </div>
          </ContainerInputsStyled>
          <ContainerButtonsStyled>
            <BtnFilterStyled onClick={onSubmitFilter}>
              Aplicar filtro
            </BtnFilterStyled>
          </ContainerButtonsStyled>
        </FormStyled>
      </MobileFilterStyled>
    </ContainerStyled>
  );
};

export default MobileFilter;
